export const getEnumDisplayValue = (enumerator, value) => {
  let displayValue = null;
  for (let key in enumerator) {
    if (enumerator[key] === value) {
      displayValue = key;
    }
  }
  return displayValue;
};
